// @ds/editable/affordanceContext
//
// Set by an outer container (currently KVGrid) when it renders the edit/lock
// affordance icon itself, next to the label. Nested `Editable` reads this
// context and suppresses its own value-side pencil — keeping the hover
// background + click, but not double-rendering the icon.

import { createContext } from "react";

export const LabelAffordanceContext = createContext<boolean>(false);
